import { AsyncAction } from '@cbgms/base/redux/async-action'
import * as types from './types'
import * as requests from '@cbgms/api/modules/concept-configuration/requests'
import { GETConceptConfigurationResponse } from '@cbgms/api/modules/concept-configuration'

export const getConceptConfigurationByConcept = (concept: string) =>
  AsyncAction<GETConceptConfigurationResponse>({
    type: [types.GET_CONCEPT_CONFIGURATION, types.GET_CONCEPT_CONFIGURATION_SUCCESS, types.GET_CONCEPT_CONFIGURATION_FAILED],
    payload: {
      api: 'support',
      request: requests.getConceptConfigurationByConcept(concept)
    }
  })

export const deleteConceptConfiguration = (uuid: string) =>
  AsyncAction<string>({
    type: [types.DELETE_CONCEPT_CONFIGURATION, types.DELETE_CONCEPT_CONFIGURATION_SUCCESS, types.DELETE_CONCEPT_CONFIGURATION_FAILED],
    payload: {
      api: 'support',
      request: {
        url: `/modules/concept-configuration/${uuid}`,
        method: 'DELETE'
      }
    }
  })
